import { render, staticRenderFns } from "./CribbageInput.vue?vue&type=template&id=df527834"
import script from "./CribbageInput.vue?vue&type=script&lang=js"
export * from "./CribbageInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports